import { useContext } from "react"
import { PagePropsContext } from "../../contexts/pageProps"

export const usePageProps = <T = unknown>() => useContext(PagePropsContext) as T
